import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-expansion-panel',
  templateUrl: './expansion-panel.component.html',
  styleUrls: ['./expansion-panel.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
/**
 * ExpansionPanel molecule
 */
export class ExpansionPanelComponent {
  @Input() title?: string;
}
